<div class="content-card">
    <ngx-spinner type="pacman"></ngx-spinner>

        @if (successMessage) {
            <alert [message]="successMessage" alertType="success"></alert>
        }
        @for (error of errorMessages; track error) {
            <alert [message]="error" alertType="error"></alert>
        }

        <form [formGroup]="importForm" class="import-form">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'RegistrationNumber' | translate }}</mat-label>
                <input matInput placeholder="{{ 'RegistrationNumber' | translate }}"
                    formControlName="registrationNumber" />
                @if (importForm.get('registrationNumber').invalid && importForm.get('registrationNumber').touched) {
                <mat-error>{{ 'InvalidField' | translate }}</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{ 'CardNumber' | translate }}</mat-label>
                <input matInput placeholder="{{ 'CardNumber' | translate }}" formControlName="cardNumber" />
                @if (importForm.get('cardNumber').invalid && importForm.get('cardNumber').touched) {
                <mat-error>{{ 'InvalidField' | translate }}</mat-error>
                }
            </mat-form-field>

            <mat-checkbox formControlName="importAddress" color="primary">
                {{ 'ImportAddress' | translate }}
            </mat-checkbox>

            <mat-checkbox formControlName="draft" color="primary">
                {{ 'Draft' | translate }}
            </mat-checkbox>

            <div class="agreement-scope-section">
                <mat-label id="employmentAgreementScopeLabel" class="agreement-scope-label">{{ 'ImportEmploymentAgreementScopeHeading' | translate }}</mat-label>
                <mat-radio-group formControlName="employmentAgreementScope" aria-labelledby="employmentAgreementScopeLabel">
                    <mat-radio-button [value]="AgreementImportScope.ActiveFromRegistry">{{ 'ImportEmploymentScopeActiveFromRegistry' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.AllFromRegistry">{{ 'ImportEmploymentScopeAllFromRegistry' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.AllFromAllRegistries">{{ 'ImportEmploymentScopeAllFromAllRegistries' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.None">{{ 'ImportEmploymentScopeNone' | translate }}</mat-radio-button>
                </mat-radio-group>

                <mat-label id="mandateAgreementScopeLabel" class="agreement-scope-label">{{ 'ImportMandateAgreementScopeHeading' | translate }}</mat-label>
                <mat-radio-group formControlName="mandateAgreementScope" aria-labelledby="mandateAgreementScopeLabel">
                    <mat-radio-button [value]="AgreementImportScope.ActiveFromRegistry">{{ 'ImportMandateScopeActiveFromRegistry' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.AllFromRegistry">{{ 'ImportMandateScopeAllFromRegistry' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.AllFromAllRegistries">{{ 'ImportMandateScopeAllFromAllRegistries' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="AgreementImportScope.None">{{ 'ImportMandateScopeNone' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="actions">
                <button mat-raised-button color="primary" type="button" (click)="onImport()">
                    {{ 'Import' | translate }}
                </button>
            </div>
        </form>
    </div>